// Stems or loose clips — decided from the files, never asked in jargon.
//
// Stems exported from one project all run from bar 1 to the same end, so they
// are the same length to within a few samples (a render's tail, an encoder's
// padding). Anything else — one file, a folder of loops and one-shots — is
// clips. The producer sees the verdict as a plain sentence and can flip it.

import { WEB_UPLOAD_LIMITS } from "./config";

export type UploadKind = "stems" | "clips";

export function classify(durationsSec: number[], toleranceSec: number = WEB_UPLOAD_LIMITS.stemToleranceSec): UploadKind {
  if (durationsSec.length < 2) return "clips";
  const min = Math.min(...durationsSec);
  const max = Math.max(...durationsSec);
  return min > 0 && max - min <= toleranceSec ? "stems" : "clips";
}
